/* eslint-disable no-inner-declarations */
import { useEffect } from "react";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import useAuth from "../hooks/useAuth";

function GetUser() {
  const { accessToken, setUser } = useAuth();
  const axiosPrivateInstance = useAxiosPrivate();
  useEffect(() => {
    if (accessToken) {
      async function getUser() {
        try {
          const { data } = await axiosPrivateInstance.get("user");
          // console.log(data);
          setUser(data);
        } catch (error) {
          console.log(error.response);
        }
      }
      getUser();
    }
  }, [accessToken]);
  return <></>;
}

export default GetUser;
